import { render, staticRenderFns } from "./warehouseServiceInfo.vue?vue&type=template&id=eda3fc0e&scoped=true&"
import script from "./warehouseServiceInfo.vue?vue&type=script&lang=js&"
export * from "./warehouseServiceInfo.vue?vue&type=script&lang=js&"
import style0 from "./warehouseServiceInfo.vue?vue&type=style&index=0&id=eda3fc0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda3fc0e",
  null
  
)

export default component.exports